import fetch from 'utils/fetch';
import { serializeMemo } from 'memo/utils/serialize';

export const REQUEST_MEMO = 'REQUEST_MEMO';
export const RECEIVE_MEMO = 'RECEIVE_MEMO';
export const MEMO_RECEIVE_FAILED = 'MEMO_RECEIVE_FAILED';

export const SAVING_MEMO = 'SAVING_MEMO';
export const MEMO_SAVE_FAILED = 'MEMO_SAVE_FAILED';
export const MEMO_SAVED = 'MEMO_SAVED';

function requestMemo(memo) {
  return {
    type: REQUEST_MEMO,
    payload: {
      memo,
    },
  };
}

function receiveMemo(memo) {
  return {
    type: RECEIVE_MEMO,
    payload: {
      memo,
    },
  };
}

function receiveFailed(error) {
  return {
    type: MEMO_RECEIVE_FAILED,
    payload: {
      error,
    },
  };
}

function savingMemo(memo) {
  return {
    type: SAVING_MEMO,
    payload: {
      memo,
    },
  };
}

function saveFailed(error) {
  return {
    type: MEMO_SAVE_FAILED,
    payload: {
      error,
    },
  };
}

function fetchMemo(memo) {
  return dispatch => {
    dispatch(requestMemo(memo));
    fetch(`/memos.json/${memo}`)
      .then(r => r.json())
      .then(memo => dispatch(receiveMemo(memo)))
      .catch(error => dispatch(receiveFailed(error)));
  };
}

function shouldFetchMemo(state) {
  const memo = state.memos.memo;
  if (!memo.memo) {
    return true;
  } else if (memo.isFetching) {
    return false;
  }

  return memo.didInvalidate;
}

export function fetchMemoIfNeeded(memo) {
  return (dispatch, getState) => {
    if (shouldFetchMemo(getState())) {
      dispatch(fetchMemo(memo));
    }
  };
}

export function saveMemo(id, page, fields) {
  return (dispatch, getState) => {
    const state = getState().memos;
    const memoAsMultipart = serializeMemo(state, fields);

    dispatch(savingMemo(id));
    return fetch(`/memos.json/${id}?page=${page}`, {
      method: 'post',
      body: memoAsMultipart,
    })
      .then(res => res.json())
      .then(updated => dispatch(receiveMemo(updated)))
      .catch(error => dispatch(saveFailed(error)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/memo/actions/memo.js